module.exports = __webpack_public_path__ + "static/img/2019@2x.79b20cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/newEvents/2019@2x.png
// module id = /cxI
// module chunks = 1